export default __webpack_public_path__ + "static/pricing-0dfb5c50379a2934e015f66c7009d4c5.jpg";